import {
  Button,
  ButtonLink,
  ImageInputFieldController,
  RadioFieldController,
  SelectFieldController,
  Stack,
  TextInputFieldController,
} from '@fukuri-admins/ui/common';
import { getTopBannersLink } from '~/utils/getLinks';
import styles from './styles.module.scss';

type GroupOption = {
  id: string;
  name: string;
  code: string;
};

type Props = {
  /** グループ一覧 */
  groupList: GroupOption[];
  /** 保存ボタンの無効化フラグ */
  isButtonDisabled: boolean;
  /** フォーム送信ハンドラ */
  onSubmit: React.ComponentProps<'form'>['onSubmit'];
};

export const CreateTopBannerFormPresentation: React.FC<Props> = ({
  groupList,
  isButtonDisabled,
  onSubmit,
}) => (
  <form onSubmit={onSubmit} className={styles.form}>
    <Stack direction='column' gap={24}>
      <ImageInputFieldController
        name='image'
        fieldWrapperProps={{
          labelType: 'required',
          labelText: 'バナー画像',
          beforeMessage: '指定サイズ：横800px × 縦280px',
        }}
        imageInput={{
          accept: 'image/jpeg,image/png',
          placeholder: '画像をアップロード',
          width: 368,
          height: 126,
        }}
      />
      <TextInputFieldController
        name='title'
        fieldWrapperProps={{
          labelType: 'required',
          labelText: 'バナー名',
          beforeMessage: '40文字まで。例)プレゼントキャンペーン！',
        }}
        textInput={{
          type: 'text',
          placeholder: 'バナー名を入力してください',
        }}
      />
      <TextInputFieldController
        name='transitionUrl'
        fieldWrapperProps={{
          labelType: 'required',
          labelText: '遷移先URL',
        }}
        textInput={{
          type: 'url',
          placeholder: '遷移先URLを入力してください',
        }}
      />
      <RadioFieldController
        name='restrictedToApp'
        fieldWrapperProps={{
          labelType: 'required',
          labelText: 'バナー遷移先',
        }}
        radioGroup={{
          direction: 'column',
          gap: 16,
          options: [
            { value: 'false', label: 'アプリ外部' },
            { value: 'true', label: 'アプリ内部' },
          ],
        }}
      />
      <RadioFieldController
        name='status'
        fieldWrapperProps={{
          labelType: 'required',
          labelText: '表示ステータス',
        }}
        radioGroup={{
          direction: 'row',
          gap: 16,
          options: [
            { value: '0', label: '表示' },
            { value: '1', label: '非表示' },
          ],
        }}
      />
      {groupList.length > 0 && (
        <SelectFieldController
          name='groupId'
          fieldWrapperProps={{
            labelText: '配信先',
            beforeMessage: '特定の企業向けに配信する場合は、グループを設定してください。',
          }}
          select={{
            placeholder: '選択してください',
            options: groupList.map(group => ({
              value: group.id,
              label: (
                <div className={styles.selectOption}>
                  <span className={styles.selectOption__name}>{group.name}</span>
                  <span className={styles.selectOption__code}>（{group.code}）</span>
                </div>
              ),
            })),
            clearable: true,
          }}
        />
      )}
      <RadioFieldController
        name='targetUserType'
        fieldWrapperProps={{
          labelType: 'required',
          labelText: '配信対象',
        }}
        radioGroup={{
          direction: 'row',
          gap: 16,
          options: [
            { value: 'everyone', label: 'すべて（従業員＋家族）' },
            { value: 'employees_only', label: '従業員のみ' },
          ],
        }}
      />
      <Stack direction='row' gap={16}>
        <ButtonLink to={getTopBannersLink()} variant='outline' size='md'>
          キャンセル
        </ButtonLink>
        <Button type='submit' size='md' disabled={isButtonDisabled}>
          作成
        </Button>
      </Stack>
    </Stack>
  </form>
);
